var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrownLeftWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.730466 4.80794L5.18785 1.09346C5.70891 0.659238 6.5 1.02976 6.5 1.70803L6.5 8.29197C6.5 8.97024 5.70892 9.34076 5.18785 8.90654L0.730466 5.19206C0.610528 5.09211 0.610528 4.90789 0.730466 4.80794Z",
    fill: "#F5F5F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrownLeftWhite);
export default __webpack_public_path__ + "static/media/arrown-left-white.1a47512958f7b0d6d5cfac7cb5190711.svg";
export { ForwardRef as ReactComponent };